import { TextAreaInput } from "@jugl-web/ui-components/cross-platform/forms/TextAreaInput";
import { useAutoResizedTextarea, useTranslations } from "@jugl-web/utils";
import { DESCRIPTION_MAX_LENGTH } from "@jugl-web/domain-resources/tasks/components/AddNewProductForm/consts";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { useRef } from "react";
import { ServiceFormValues } from "../../types";

interface ComponentProps {
  register: UseFormRegister<ServiceFormValues>;
  errors: FieldErrors<ServiceFormValues>;
  description: string;
}

export const DescriptionField = ({
  register,
  errors,
  description = "",
}: ComponentProps) => {
  const { t } = useTranslations();

  const descriptionTextareaRef = useRef<HTMLTextAreaElement | null>(null);

  const { textareaProps: descriptionTextareaProps } = useAutoResizedTextarea(
    descriptionTextareaRef
  );

  const errorMessage =
    description.length > DESCRIPTION_MAX_LENGTH - 11
      ? `${description.length}/${DESCRIPTION_MAX_LENGTH}`
      : (errors.description?.message as string | undefined);

  return (
    <TextAreaInput
      placeholder={t({
        id: "common.enter",
        defaultMessage: "Enter",
      })}
      label={t({
        id: "inventory-item-form-page.description",
        defaultMessage: "Description",
      })}
      {...descriptionTextareaProps}
      isInvalid={!!errors.description}
      isRequired
      errorMessage={errorMessage}
      {...register("description", {
        maxLength: {
          value: DESCRIPTION_MAX_LENGTH,
          message: `${description?.length}/${DESCRIPTION_MAX_LENGTH}`,
        },
        setValueAs: (value) => value.trim(),
        required: {
          value: true,
          message: t({
            id: "inventory-item-form-page.mandatory-field",
            defaultMessage: "Mandatory field",
          }),
        },
        validate: (value) => !!value.trim(),
      })}
    />
  );
};
